<div class="mobile-notification">
  <button
    nz-button
    nzType="text"
    nzSize="large"
    class="mobile-notification__close-btn"
    aria-label="Close"
    (click)="onDestroyModal()"
  >
    <span nz-icon nzType="close" nzTheme="outline"></span>
  </button>

  <nz-card class="mobile-notification__card">
    <div class="mobile-notification__card__content">
      <img
        ngSrc="assets/images/logos/moxi-driver-app-logo.webp"
        width="80"
        height="80"
        alt="Moxi Driver App Logo"
      />

      <h1>{{ 'mobileNotification.title' | translate }}</h1>
      <p>
        {{ 'mobileNotification.description' | translate }}
      </p>

      <div class="app-buttons">
        <a
          nz-button
          nzType="primary"
          class="app-button"
          target="_blank"
          [href]="appStoreLink"
        >
          <span nz-icon nzType="apple" nzTheme="outline"></span>
          {{ 'mobileNotification.appStore' | translate }}
        </a>

        <a
          nz-button
          nzType="primary"
          class="app-button"
          target="_blank"
          [href]="playStoreLink"
        >
          <span nz-icon nzType="google" nzTheme="outline"></span>
          {{ 'mobileNotification.playStore' | translate }}
        </a>
      </div>
    </div>
  </nz-card>

  <button nz-button nzType="text" (click)="onDestroyModal()">
    {{ 'mobileNotification.continue' | translate }}
  </button>
</div>
